package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.data.backup.HotplBackupJsonCodec
import fyi.moko.hotpl.data.backup.LocalBackupManager
import fyi.moko.hotpl.data.backup.SAMPLE_BACKUP_JSON
import fyi.moko.hotpl.domain.service.AuthService

/**
 * Seeds the bundled sample places (LA Koreatown) by merging them into the database.
 * Uses [LocalBackupManager.merge], so it appends without deleting any existing data —
 * intended for first-time users starting from an empty list.
 */
class LoadSampleDataUseCase(
    private val backupManager: LocalBackupManager,
) {
    suspend operator fun invoke() {
        val prepared = HotplBackupJsonCodec.decode(SAMPLE_BACKUP_JSON)
        backupManager.merge(prepared.file.places)
    }
}
